import { artAssetCardModel } from '@entities/art-asset';

import type { SearchData, SearchResponse } from '../types';

export function mapSearchToUI(response: SearchResponse): SearchData {
  const { data } = response;

  return {
    artists: {
      data: data.artists.data.map((artist) => ({
        slug: artist.slug,
        id: artist.id,
        name: artist.name,
        artAssetsCount: artist.art_assets_count,
        photo: artist.photo,
      })),
      totalCount: data.artists.total_count,
    },
    artworks: {
      data: data.art_assets.data.map((artwork) => artAssetCardModel.mapApiToData(artwork)),
      totalCount: data.art_assets.total_count,
    },
    selections: {
      data: data.selections.data.map((selection) => ({
        cover: selection.cover,
        slug: selection.slug,
        title: selection.title,
      })),
      totalCount: data.selections.total_count,
    },
  };
}
